import { useEffect, useState } from "react";
import Select from "react-select";
import { useQuery } from "@tanstack/react-query";
import { fetchFranchiseDropdownDD } from "services/dropdown";
import { DROPDOWN_STALE_TIME } from "utils/constants";
import { Controller } from "react-hook-form";
import { useSelector } from "react-redux";

const FranchiseDropdownWithCode = ({
  errors,
  control,
  setValue,
  getValues,
  watch,
  formKey,
  defaultValue,
  required,
  all_zone_franchise = 0,
  copyRateMode = false,
}) => {
  const key = formKey || "franchise";
  const selected = watch(key);
  const login = useSelector((state) => state.jwtAuthreducer);
  const [localFranchiseId, setLocalFranchiseId] = useState(null);
  const [isReadOnly, setIsReadOnly] = useState(false);

  useEffect(() => {
    const sub_franchise = localStorage.getItem("sub_franchise");
    const is_franchise_employee = localStorage.getItem("is_franchise_employee");
    const is_super_employee = localStorage.getItem("is_super_employee");

    const isReadOnly =
      Number(sub_franchise) === 1 ||
      Number(is_franchise_employee) === 1 ||
      Number(is_super_employee) === 1;

    setIsReadOnly(isReadOnly);
  }, []);

  const { data, isLoading, refetch, error } = useQuery(
    ["franchise-dropdown"],
    () => fetchFranchiseDropdownDD({ ...login, all_zone_franchise }),
    {
      keepPreviousData: false,
      staleTime: DROPDOWN_STALE_TIME,
    }
  );

  useEffect(() => {
    refetch();
  }, [login]);

  useEffect(() => {
    if (copyRateMode) {
      const storedId = localStorage.getItem("franchise_id");
      setLocalFranchiseId(storedId);
    }
  }, [copyRateMode]);

  useEffect(() => {
    if (data) {
      const options =
        data?.data?.data?.map((item) => ({
          value: item.id,
          label: item.franchise_code,
        })) || [];

      let valueToSet = defaultValue;

      if (copyRateMode && localFranchiseId) {
        valueToSet = Number(localFranchiseId);
      }

      const defaultOption = options.find(
        (option) => option.value === valueToSet
      );

      if (defaultOption) {
        setValue(key, defaultOption.value, { shouldValidate: true });
      } else {
        setValue(key, "", { shouldValidate: true });
      }
    }
  }, [data, defaultValue, localFranchiseId, setValue, key, copyRateMode]);

  if (isLoading) return <div>Loading...</div>;
  if (error) return <div>Error loading franchise type</div>;

  const options =
    data?.data?.data?.map((item) => ({
      value: item.id,
      label: item.franchise_code,
    })) || [];

  const selectedOption =
    options.find((option) => option.value === selected) || null;

  return (
    <>
      {copyRateMode && isReadOnly ? (
        <input
          type="text"
          value={
            options.find(
              (option) =>
                option.value ===
                Number(copyRateMode ? localFranchiseId : selected)
            )?.label || ""
          }
          readOnly
          disabled
          className={`form-control ${errors[key] ? "is-invalid" : ""}`}
        />
      ) : (
        <Controller
          name={key}
          control={control}
          rules={{
            required: required ? "Franchise is required" : false,
            validate: (value) => {
              if (required && !value) return "Franchise is required";
              return true;
            },
          }}
          render={({ field }) => (
            <Select
              {...field}
              options={options}
              isClearable
              value={selectedOption || null}
              placeholder={`Select Franchise`}
              menuPortalTarget={document.body}
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
              }}
              onChange={(selectedOption) => {
                const value = selectedOption ? selectedOption.value : "";
                field.onChange(value);
                setValue(key, value, { shouldValidate: true });
              }}
              className={`react-select-container ${
                errors[key] ? "is-invalid" : ""
              }`}
            />
          )}
        />
      )}
    </>
  );
};

export default FranchiseDropdownWithCode;
